import Link from "next/link";
import SideBarItem from "./sidebar-item";
import { cn } from "@/utils/css";
import type { ISidebarLink } from "@/types/layout/navigation";
import DinesLink from "@/components/library/Misc/DinesLink";

interface IMainSideBarLinks {
  links: ISidebarLink[];
  selected: string;
  collapseSidebar: boolean;
}

const MainSideBarLinks: React.FC<IMainSideBarLinks> = ({
  links,
  selected,
  collapseSidebar,
}) => (
  <div className="w-full flex-grow p-4">
    {links.map((item) => (
      <div
        className="flex w-full flex-col items-start"
        key={item.id}
        id={`sidebar-${item.id}`}
        data-testid={`sidebar-${item.id}`}
        data-active={selected === item.id}
      >
        <>
          {item.type === "action" ? (
            <>
              <div
                role="button"
                className="w-full"
                onClick={(e) => {
                  e.preventDefault();
                  item.action();
                }}
                onKeyPress={(e) => {
                  e.preventDefault();
                  item.action();
                }}
                tabIndex={0}
              >
                <SideBarItem
                  collapseSidebar={collapseSidebar}
                  selected={selected}
                  item={item}
                />
              </div>
            </>
          ) : (
            <>
              {item.external === false ? (
                <DinesLink href={item.url} className="w-full">
                  <div
                    role="button"
                    id={`sidebar-${item.id}-button`}
                    className={cn(
                      "flex w-full",
                      selected === item.id &&
                        "font-bold text-dines-purple-darkest"
                    )}
                  >
                    <SideBarItem
                      collapseSidebar={collapseSidebar}
                      selected={selected}
                      item={item}
                    />
                  </div>
                </DinesLink>
              ) : (
                <DinesLink
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  className={cn(
                    "w-full",
                    selected === item.id &&
                      "font-bold text-dines-purple-darkest"
                  )}
                >
                  <SideBarItem
                    collapseSidebar={collapseSidebar}
                    selected={selected}
                    item={item}
                  />
                </DinesLink>
              )}
            </>
          )}
        </>
      </div>
    ))}
  </div>
);

export default MainSideBarLinks;
